export const CURRENT_USERS = 'CURRENT_USERS';
